import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../../logo-bigl.svg';

export default function Header() {
    const location = useLocation();
    const [isLoading, setLoading] = useState(true);
    // const [isProjects, setProjects] = useState(null);
    const [blog, setBlog] = useState();

    useEffect(() => {
        const fetchBlog = async () => {
            const data = await fetch(`https://bigl-architectes.fr/wp-json/`);
            const blog = await data.json();
            setBlog(blog);
            setLoading(false);
        }
        fetchBlog()
        .catch((error) => {console.error(error)});
    }, []);

    // useEffect(() => {
    //     let pathElements = location.pathname.split("/").filter((item) => item)
    //     let sticky = pathElements.length === 1 ? "sticky" : null
    //     setProjects(sticky);
    //   }, [location]) 

    return ( !isLoading && 
        <header id="header">
            <h1>
                <NavLink
                    to={`/${location.hash}`}
                >
                    <Logo alt={blog?.name || "Loading..."} />
                </NavLink>
            </h1>
            <nav>
                <ul>
                    <li>
                        <NavLink
                            to={`${location.pathname}#FR`}
                            className={ () => { return !window.location.hash || window.location.hash === '#FR' ? "active":"" } }
                        >
                            Français
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`${location.pathname}#EN`}
                            className={ () => { return window.location.hash === '#EN' ? "active":"" } }
                        >
                            English
                        </NavLink>
                    </li>
                    <li className='mobile-link'>
                        <NavLink
                            to={`/${location.hash}`}
                        >
                            <span className='round'></span>
                            <span className='square'></span>
                        </NavLink>
                    </li>
                </ul>
            </nav>

        </header>
    )
}